import React, { useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import InputImagenesTitulo from "../../components/imagenes_con_titulo/InputImagenesTitulo";
import useTopStore from "../../store/topStore";
import Loader from "../../components/Loader";
import SelectMultiForm from '../../components/SelectMultiForm';
const TopPage = () => {

  const { isLoading, iniciar, productos, multiImagenesTemp, handleChangeImagen, handleSave, sucursales, sucursalSelecionada, handleSucursales,esMostrar } = useTopStore();
  const sucursalId = sucursalSelecionada[0]?.value;
  
  useEffect(() => {
    iniciar();
  }, []);
  
  return (
    <>
      <MasterLayout>
        {
          isLoading ?
          <Loader /> :
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Top de productos</h4>
                  <button className="btn btn-primary" onClick={handleSave}>Guardar</button>
                </div>
                <div className="card-body">
                  <SelectMultiForm
                    col="col-sm-12"
                    datos={sucursales} 
                    change={handleSucursales}
                    values={sucursalSelecionada}
                    placeholder="Seleccione una o varias sucursales"
                    name="sucursalesOrden"
                    isMulti={false}
                  />
                  {!sucursalId && (
                    <div className="text-center text-secondary-light py-32">
                      Aún no hay sucursales para configurar el top.
                    </div>
                  )}
                  {sucursalId && productos.length === 0 && (
                    <div className="text-center text-secondary-light py-32">
                      Aún no hay productos para destacar.
                    </div>
                  )}
	                  {
	                    esMostrar && sucursalId && productos.length > 0 &&
	                    <InputImagenesTitulo
	                      multiImagenes={multiImagenesTemp.filter(imagenes=>imagenes.sucursal === sucursalId)}
	                      handleChangeImagen={handleChangeImagen}
	                      ratio={4/3}
	                      maxImages={4}
	                      name="IMAGENES_TOP"
	                      categorias={productos}
                        categoriaLabel="Producto"
	                      sucursal = {sucursalId}
	                    />
	                  }
                </div>
              </div>
            </div>
          </div>
        }
      </MasterLayout>
    </>
  );
};

export default TopPage;
